import convertImageToBase64 from '../../utils/converitr-imagen-base64';
import { formSchema } from '../../validaciones/validacionPromocion';

export const promocionesSlice = (set,get) => ({
    insertarPromocion: () => {
        const result = formSchema.safeParse({ ...get().datos, imagen: get().imagen });
        if (!result.success) {
            console.log(result.error.errors);
            console.log(result.error.flatten().fieldErrors);
            set({error:result.error.flatten().fieldErrors})
            return;
        }
        else{
            set({error:null})
        }
        console.log('get().fileImagen',get().fileImagen);
        const formData = new FormData();
        formData.append('miArchivo', get().fileImagen);
        formData.append('datos', JSON.stringify(get().datos));
        fetch("/p_promocion",{
            method: get().datos.id == 0 ? "POST" : "PUT",
            body: formData
        })
        .then((res) => res.json())
        .then((data) => {
            console.log('El dato',data);
            if(data.status == 1){
                // Success
                get().elNavigate(-1);
                get().limpiar();
            }
        })
        .catch((error) => {
            console.log('Error',error);
        });
    },
    obtenerImagen: async (id,imagen) => {
        let laImagen = `/promociones/${id}/${imagen}`;
        let base64 = await convertImageToBase64(laImagen);
        set({ datos:{ ...get().datos, imagen: imagen }, imagen: base64 });
    },
    obtenerPromocion: async() => {
        if(get().datos.id != 0){
            await fetch("/p_promocion",{
                method: "PATCH",
                headers:{"Content-Type": "application/json",},
                body: JSON.stringify({id:get().datos.id})
            })
            .then((res) => res.json())
            .then((data) => {
                console.log('data',data);
                if(data.status == 1){
                   set({datos:{
                        ...get().datos,
                        nombre:data.data[0][0].NOMBRE_PROMOCION_PRO,
                        texto_uno:data.data[0][0].TEXTO_UNO_PRO,
                        texto_dos:data.data[0][0].TEXTO_DOS_PRO,
                        hexFondo:data.data[0][0].COLOR_FONDO_PRO,
                        hexTexto:data.data[0][0].COLOR_TEXTO_PRO,
                        esDetalle:data.data[0][0].ES_DETALLE_PRO,
                        detalle:data.data[0][0].DETALLE_PROMO_PRO,
                        sucursales:data.data[1].map((item) => { return { value: item.ID_SUC, label: item.NOMBRE_SUCURSAL_SUC } }),
                        estatus:data.data[0][0].ESTATUS_PRO
                    }});
                    get().obtenerImagen(data.data[0][0].ID_PRO,data.data[0][0].IMAGEN_PRO);
                }
            })
            .catch((error) => {
                console.log('Error',error);
            });
        }   
    }
})